const onLeaveRegister = function () {
  // Should not reset store if still on register path
  if (App.getStore("navigation").request.matches("register")) {
    return
  }
  window.App.getStore("register").reset()
}

const getDefaultLaunchedFrom = ({ location }) =>
  location.pathname
    .split("register/")
    .join("")
    .split("group/")
    .join("")
    .concat("about/")

export default {
  // Matching register/ | register/offingId/
  path: "/library/:resourceSlug/register/:cohortId(\\d+)?/(thank-you)?/",
  components: {
    primary: require("library/show/components/LibraryResourceContainer")
      .default,
    modal: require("./components/RegisterFlow").default
  },
  onLeave: onLeaveRegister,
  getDefaultLaunchedFrom
}
